export interface Planet {
    id: number;
    name: string;
    /** Order is guaranteed. Id is not */
    order: number;
    color: number;
    colorCode: string;
    badgePath: string;
    iconPath: string;
}

export class Planets {
    public static readonly Default: Planet = { id: 0, name: "Default", order: 0, color: 0xffffff, colorCode: "#ffffff", badgePath: "", iconPath: "" };
    public static readonly R: Planet = { id: 1, name: "R", order: 1, color: 0x00de0e, colorCode: "#00de0e", badgePath: require("/src/assets/online-assets/sprites/reward-r.png"), iconPath: require("/src/assets/qci/sprites/planets/r-small.png") };
    public static readonly I: Planet = { id: 2, name: "I", order: 2, color: 0x0033cc, colorCode: "#0033cc", badgePath: require("/src/assets/online-assets/sprites/reward-i.png"), iconPath: require("/src/assets/qci/sprites/planets/i-small.png") };
    public static readonly A: Planet = { id: 3, name: "A", order: 3, color: 0x9500ca, colorCode: "#9500ca", badgePath: require("/src/assets/online-assets/sprites/reward-a.png"), iconPath: require("/src/assets/qci/sprites/planets/a-small.png") };
    public static readonly S: Planet = { id: 4, name: "S", order: 4, color: 0xff0700, colorCode: "#ff0700", badgePath: require("/src/assets/online-assets/sprites/reward-s.png"), iconPath: require("/src/assets/qci/sprites/planets/s-small.png") };
    public static readonly E: Planet = { id: 5, name: "E", order: 5, color: 0xffae00, colorCode: "#ffae00", badgePath: require("/src/assets/online-assets/sprites/reward-e.png"), iconPath: require("/src/assets/qci/sprites/planets/e-small.png") };
    public static readonly C: Planet = { id: 6, name: "C", order: 6, color: 0xedfd00, colorCode: "#edfd00", badgePath: require("/src/assets/online-assets/sprites/reward-c.png"), iconPath: require("/src/assets/qci/sprites/planets/c-small.png") };

    public static All: Planet[] = [
        Planets.R,
        Planets.I,
        Planets.A,
        Planets.S,
        Planets.E,
        Planets.C,
    ];

    /** Returns a list of planets with an Order value less than the planet passed in. Useful when calculating rewards */
    public static GetPlanetListByPlanetId(id: number): Planet[] {
        let currentPlanet = this.FindById(id);
        return this.All.filter(x => x.order <= currentPlanet.order && x.order > 0);
    }

    public static FindById(id: number): Planet {
        return this.All.find(x => x.id === id) || this.Default;
    }

    public static GetNext(planet: Planet) {
        let order = planet.order + 1;
        return this.All.find(x => x.order === order) || this.Default;
    }

    public static GetPrevious(planet: Planet) {
        let order = planet.order - 1;
        return this.All.find(x => x.order === order) || this.Default;
    }
}



// WEBPACK FOOTER //
// ./src/constants/Planets.ts